import React from 'react';
import { createIcon } from './create-icon';
import './icon-alert-filled.scss';

export const IconAlertFilled = createIcon(<div className="icon-alert-filled" />);